export default {
  comment: '',
  isPassed: '10',
  errorMessage: '',
  selectedOptionId: [],
  text: '',
  texts: [],
  evidences: []
}



// WEBPACK FOOTER //
// ./src/views/question-editor/format/convert-fields/answer.js